import { render } from "./CartProductsContainer.vue?vue&type=template&id=9746771c"
import script from "./CartProductsContainer.vue?vue&type=script&lang=js"
export * from "./CartProductsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__